import { CheckCircle2 } from "lucide-react";
import { useLanguage } from "@/lib/i18n";

const content = {
  fr: {
    heading: "Qu'est-ce que ReFound?",
    description:
      "ReFound est une application mobile gratuite pour iPhone et Android, conçue au Canada, qui transforme vos reçus papier en reçus numériques clairs et utiles. Vous prenez une photo de votre reçu; ReFound reconnaît le magasin et les articles, ajoute les vrais noms de produits avec leurs images, estime les délais de retour et les garanties, puis garde tout prêt à montrer en magasin — code-barres inclus.",
    facts: [
      { label: "Prix", value: "Gratuit à télécharger" },
      { label: "Plateformes", value: "iPhone (App Store) et Android (Google Play)" },
      { label: "Langues", value: "Français et anglais" },
      { label: "Pays", value: "Canada" },
      {
        label: "Magasins",
        value: "Canadian Tire, Costco, Walmart, Home Depot, IKEA et plus",
      },
      {
        label: "Idéal pour",
        value: "Retours en magasin, garanties et organisation des reçus",
      },
    ],
  },
  en: {
    heading: "What is ReFound?",
    description:
      "ReFound is a free mobile app for iPhone and Android, made in Canada, that turns your paper receipts into clear, useful digital receipts. You take a photo of your receipt; ReFound recognizes the store and the items, adds real product names with images, estimates return deadlines and warranties, and keeps everything ready to show in store — barcode included.",
    facts: [
      { label: "Price", value: "Free to download" },
      { label: "Platforms", value: "iPhone (App Store) and Android (Google Play)" },
      { label: "Languages", value: "English and French" },
      { label: "Country", value: "Canada" },
      {
        label: "Stores",
        value: "Canadian Tire, Costco, Walmart, Home Depot, IKEA and more",
      },
      {
        label: "Best for",
        value: "In-store returns, warranties and receipt organization",
      },
    ],
  },
};

export function AboutRefound() {
  const { language } = useLanguage();
  const c = content[language];

  return (
    <section id="about" className="py-20 sm:py-28 bg-secondary/30">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="glass-card rounded-3xl p-8 sm:p-12 animate-fade-up">
            <h2 className="font-heading text-3xl sm:text-4xl font-bold text-foreground mb-5">
              {c.heading}
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed mb-8">
              {c.description}
            </p>

            {/* Quick facts — easy to read for people, easy to parse for AI assistants */}
            <dl className="grid sm:grid-cols-2 gap-x-8 gap-y-4">
              {c.facts.map((fact) => (
                <div key={fact.label} className="flex items-start gap-3">
                  <CheckCircle2 className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                  <div>
                    <dt className="text-sm font-semibold text-foreground inline">
                      {fact.label} :{" "}
                    </dt>
                    <dd className="text-sm text-muted-foreground inline">
                      {fact.value}
                    </dd>
                  </div>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}
